export function layoutRegister(dashboardName, defaultLayout) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'LAYOUT_REGISTER',
                dashboardName,
                defaultLayout,
            })
        );
}

export function layoutReset(dashboardName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'LAYOUT_RESET',
                dashboardName,
                updatePreferences: true,
            })
        );
}

export function layoutUpdate(dashboardName, layout) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'LAYOUT_UPDATE',
                dashboardName,
                layout,
                updatePreferences: true,
            })
        );
}

export function layoutUnregister(dashboardName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'LAYOUT_UNREGISTER',
                dashboardName,
            })
        );
}
